<template>
    <div class="zt-full-layout full-height-page-layout">
        <div :class="['zt-full-content', {'zt-full-content-while': isWhileBg}]" ref="contentDom">
            <EeceptionWithReload :visible="error" :info="errorText" @reload="reload"/>
            <div v-show="!loading">
                <slot></slot>
            </div>
            <div v-if="loading" v-loading="true" :style="{height: `${height}px`}"></div>
        </div>
    </div>
</template>

<script>
import {ref, onMounted} from 'vue';
import EeceptionWithReload from './Exceptions/ExceptionWithReload';
export default {
    components: {
        EeceptionWithReload
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        },
        errorText: {
            type: String,
            default: '加载失败'
        },
        isWhileBg: {
            type: Boolean,
            default: true
        }
    },
    setup(props, context) {
        const height = ref(0);
        const contentDom = ref(null);
        onMounted(() => {
            height.value = contentDom.value.clientHeight;
        });
        const reload = () => {
            context.emit('reload');
        };
        return {
            contentDom,
            height,
            reload
        }
    }
}
</script>

<style lang="scss">
.zt-full-layout {
    .zt-full-content {
        position: relative;
        min-height: 100%;
        box-sizing: border-box;
    }

    .zt-full-content-while {
        background: #ffffff;
        -webkit-box-shadow: 0 10px 20px 0 #ebeff5;
        box-shadow: 0 10px 20px 0 #ebeff5;
        padding: 20px;
    }
    .el-loading-mask {
        background-color: transparent;
    }
}
</style>
